import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	const hasCaregivers = !(
		injured.caregiversDto &&
		['0', ''].includes(injured.caregiversDto.hasCaregivers)
	)

	let caregiversInfoList = []
	if (
		injured.caregiversDto &&
		injured.caregiversDto.caregiversInfoList.length
	) {
		caregiversInfoList = injured.caregiversDto.caregiversInfoList
	}

	const modal = [
		{
			label: '护理人身份',
			value: '',
			key: 'caregiversIdentity',
			selectOption: setting.caregiversIdentityList,
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '姓名',
			value: '',
			key: 'caregiversName',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					max: 16,
					message: '长度不能超过16位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '工作单位',
			value: '',
			key: 'workingPlace',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					max: 50,
					message: '长度不能超过50位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '收入/收费',
			value: '',
			key: 'nursingCost',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					pattern: /(^[0-9]{1,6}$)|(^[0-9]{1,6}[\\.]{1}[0-9]{1,2}$)/,
					message: '请输入7位数内正确金额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '护理起止时间',
			value: [],
			key: 'timeArr',
			type: 'daterange',
			notNull: '1',
			canEdit: true,
			formSpan: 6,
			allowClear: false,
		},
		{
			label: '备注',
			value: '',
			key: 'remark',
			type: 'text',
			notNull: '0',
			canEdit: true,
			formSpan: 3,
			rules: [
				{
					max: 100,
					message: '长度不能超过100位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '护理起始时间',
			value: '',
			key: 'beginTime',
			type: 'hide',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			allowClear: false,
		},
		{
			label: '护理截止时间',
			value: '',
			key: 'endTime',
			type: 'hide',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			allowClear: false,
		},
	]

	const list = caregiversInfoList.map((item, index) => {
		let beginTime = item.beginTime
			? moment(formatDate(item.beginTime), 'YYYY-MM-DD')
			: ''
		let endTime = item.endTime
			? moment(formatDate(item.endTime), 'YYYY-MM-DD')
			: ''
		const valArr = [
			item.caregiversIdentity,
			item.caregiversName,
			item.workingPlace,
			item.nursingCost,
			beginTime && endTime ? [beginTime, endTime] : [],
			item.remark,
			beginTime,
			endTime,
		]

		let arr = modal.map((moadlItem, valIndex) => {
			let symbol = ''
			if (moadlItem.key == 'nursingCost') {
				symbol = item.caregiversIdentity === '01' ? '元/月' : '元/日'
			}
			return {
				...moadlItem,
				value: valArr[valIndex],
				symbol,
			}
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '护理人信息',
		key: 'caregiversDto.caregiversInfoList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		caregiversDto: {
			hasCaregivers: hasCaregivers,
		},
	}

	return obj
}
